/// <reference path="./d/app.d.ts" />

class CookieAcceptor
{
	private $root : JQuery;
	private cookieKey = 'cookies_accepted';

	constructor()
	{
		this.$root = $('.cookie-acceptor');
		this.$root.find("button").click(() => {
			this.accept();
			this.hide();
		});
	}

	hasBeenAccepted()
	{
		const val = cookie.read(this.cookieKey);
		return !!val;
	}

	show()
	{
		this.$root.show();
	}

	accept()
	{
		cookie.create(this.cookieKey, Date.now());
	}

	hide()
	{
		this.$root.hide();
	}
}
